import { Box, Button, CircularProgress } from '@mui/material'
import SimpleTable from 'common/components/SimpleTable'
import TableSkeleton from 'common/components/TableSkeleton'
import { getLocaleDateString } from 'common/libs/fechas'
import { useEffect, useState } from 'react'
import { InvoiceHelper } from '../helpers/InvoiceHelper'

/**
 * The EfacturasList component
 * @component
 *
 * @param {Object} props
 * @param {Array} props.efacturasList
 * @param {boolean} props.loader
 * @returns {JSX.Element}
 */

const EfacturasList = ({ efacturasList, loading }) => {
  const [fileLoading, setFileLoading] = useState(false)
  const [facturas, setFacturas] = useState([])

  useEffect(() => {
    setFacturas(efacturasList)
  }, [efacturasList])

  const downloadFileHandler = (event, row) => {
    const { fichero, nombre_archivo } = row
    event.stopPropagation()
    setFileLoading(true)

    try {
      const decodedData = atob(fichero)
      const blob = new Blob([decodedData], { type: 'application/xml' })
      const url = window.URL.createObjectURL(blob)
      const downloadLink = document.createElement('a')
      downloadLink.setAttribute('href', url)
      downloadLink.setAttribute('download', nombre_archivo)
      downloadLink.click()
      downloadLink.remove()
    } finally {
      setFileLoading(false)
    }
  }

  return (
    <Box id="efacturas-compras-list">
      {loading ? (
        <TableSkeleton />
      ) : (
        <SimpleTable
          header_cell_style={{ padding: '5px' }}
          table_style={{ width: '100%', borderCollapse: 'collapse', display: 'table' }}
          container_style={{
            marginBottom: '5px',
            borderRadius: '5px',
            // marginTop: '10px',
          }}
          generic_cell_style={{
            textAlign: 'left',
            padding: '15px 10px',
          }}
          hideHeader={false}
          header_style={{
            textAlign: 'left',
            borderRadius: '5px',
            padding: '10px',
          }}
          stripped={true}
          loading={loading}
          dataSource={facturas}
          fields={[
            {
              field: 'fecha_grabacion',
              title: 'Fecha Grabación',
              customGetter: (item) => {
                return getLocaleDateString(item.fecha_grabacion)
              },
            },
            {
              field: 'serie_factura',
              title: 'Serie Factura',
            },
            {
              field: 'numero_factura',
              title: 'Número Factura',
            },
            {
              field: 'fecha_factura',
              title: 'Fecha Factura',
              customGetter: (item) => {
                return getLocaleDateString(item.fecha_factura)
              },
            },
            {
              field: 'nombre_archivo',
              title: 'Nombre Archivo',
            },
            {
              field: 'status',
              title: 'Status',
              customGetter: (item) => {
                return InvoiceHelper.getStatus(item.status)
              },
            },
            {
              field: 'error_integracion',
              title: 'Error Integración',
            },
            {
              field: 'error_validacion',
              title: 'Error Validación',
            },
            {
              field: 'descargar',
              title: 'Descargar',
              customGetter: (item) => {
                return (
                  <Button
                    onClick={(e) => downloadFileHandler(e, item)}
                    sx={{ padding: '1px 15px' }}
                    disabled={fileLoading}
                  >
                    {fileLoading && <CircularProgress size={20} sx={{ position: 'absolute' }} />}
                    descargar
                  </Button>
                )
              },
            },
          ]}
        />
      )}
    </Box>
  )
}

export default EfacturasList
